import React from 'react';
import { observer } from 'mobx-react';
import { ModalStore } from 'ui/base/modal';
import { ButtonClickEvent } from 'ui/base/types';
import { StandardPage } from 'ui/base/page/standard_page';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './bandwidth_settings.module.css';
import bandwidthSettingsMessages from './bandwidth_settings_messages';

type ModalStyles = {
  modalHeaderRow: string;
  row: string;
  modalContainer: string;
  modalTitleText: string;
  modalSupportIcon: string;
  closeIcon: string;
  content: string;
  informationText: string;
};

const themedStyles: ThemedStyles<ModalStyles> = {
  [Theme.DAYLIGHT]: {
    modalHeaderRow: baseStyles.baseModalHeaderRow,
    row: baseStyles.baseRow,
    modalTitleText: baseStyles.daylightModalTitleText,
    modalContainer: baseStyles.baseModalContainer,
    modalSupportIcon: baseStyles.daylightModalSupportIcon,
    closeIcon: baseStyles.daylightCloseIcon,
    content: baseStyles.baseContent,
    informationText: baseStyles.daylightInformationText,
  },
  [Theme.MIDNIGHT]: {
    modalHeaderRow: baseStyles.baseModalHeaderRow,
    row: baseStyles.baseRow,
    modalTitleText: baseStyles.midnightModalTitleText,
    modalContainer: baseStyles.baseModalContainer,
    modalSupportIcon: baseStyles.midnightModalSupportIcon,
    closeIcon: baseStyles.midnightCloseIcon,
    content: baseStyles.baseContent,
    informationText: baseStyles.midnightInformationText,
  },
};

type BufferBloatInformationModalProps = {
  store: ModalStore;
};
export const BufferBloatInformationModal = observer(({ store }: BufferBloatInformationModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modalContainer}>
      <StandardPage>
        <div className={styles.modalHeaderRow}>
          <div className={styles.row}>
            <div className={styles.modalSupportIcon}/>
            <div className={styles.modalTitleText}>
              {bandwidthSettingsMessages.whatIsBufferbloat()}
            </div>
          </div>
          <button className={styles.closeIcon} onClick={onClose}/>
        </div>
        <div className={styles.informationText}>
          {bandwidthSettingsMessages.antiBufferBloatInformation()}
        </div>
      </StandardPage>
    </div>
  );
});

type BandwidthControlsInformationModalProps = {
  store: ModalStore;
};
export const BandwidthControlsInformationModal = observer(({ store }: BandwidthControlsInformationModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modalContainer}>
      <StandardPage>
        <div className={styles.modalHeaderRow}>
          <div className={styles.row}>
            <div className={styles.modalSupportIcon}/>
            <div className={styles.modalTitleText}>
              {bandwidthSettingsMessages.whatIsBandwidthControls()}
            </div>
          </div>
          <button className={styles.closeIcon} onClick={onClose}/>
        </div>
        <div className={styles.content}>
          <div className={styles.informationText}>
            {bandwidthSettingsMessages.bandwidthControlsInformation()}
          </div>
        </div>
      </StandardPage>
    </div>
  );
});
